<template>
  <post-list-item
    v-for="post in postList"
    :key="post.id"
    :post="post"
  ></post-list-item>
</template>

<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const postList = computed(() => store.getters["post/getPosts"]);
    onMounted(async () => {
      await store.dispatch("post/fetchPosts");
      // const postIds = posts.map((post) => post.id);
      Promise.all([
        // store.dispatch("like/fetchAllUserLikePost", { postIds: postIds }),
        // store.dispatch("like/fetchAllLikePost", { postIds: postIds }),
        // store.dispatch("like/fetchSpecificUserLikePost", { postIds: postIds }),
        // store.dispatch("comment/fetchAllCommentPost", { postIds: postIds }),
        // store.dispatch("comment/fetchAllCommentCountPost", { postIds: postIds })
      ]);
    });
    return {
      postList,
    };
  },
};
</script>